import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BookingReqDto } from '../_dtos/bookingReqDto';
import { BookingResDto } from '../_dtos/bookingResDto';
import { EditResourceReqDto } from '../_dtos/editResourceReqDto';
import { SkipLoading } from '../_interceptors/loading.interceptor';
import { SkipErrorToast } from '../_interceptors/error.interceptor';

@Injectable({
  providedIn: 'root',
})
export class BookingsService {
  private readonly bookingsUri = environment.backendBaseUrl + '/bookings';

  constructor(private http: HttpClient) {}

  // Synchronous until the business is set up (up to about a minute); the form shows its own error toast
  createBooking(bookingData: BookingReqDto): Observable<BookingResDto> {
    return this.http.post<BookingResDto>(this.bookingsUri, bookingData, {
      context: new HttpContext()
        .set(SkipLoading, true)
        .set(SkipErrorToast, true),
    });
  }

  updateBooking(
    id: string,
    editResourceData: EditResourceReqDto,
  ): Observable<void> {
    return this.http.patch<void>(this.bookingUri(id), editResourceData);
  }

  deleteBooking(id: string): Observable<void> {
    return this.http.delete<void>(this.bookingUri(id));
  }

  // The business ID is its mail address
  private bookingUri(id: string): string {
    return `${this.bookingsUri}/${encodeURIComponent(id)}`;
  }
}
